// extracted by mini-css-extract-plugin
export default {"icon":"HeaderSearch_icon__ijcVN","container":"HeaderSearch_container__Rj5bi"};